import { TagWrapper } from "./style"
import { graphql, useStaticQuery } from "gatsby"

import React from "react"
import Tag from "./singleTag"

type IntroProps = {}

const TagList: React.FunctionComponent<IntroProps> = props => {
  const AllTagsQuery = useStaticQuery(graphql`
    query {
      allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
        edges {
          node {
            frontmatter {
              tags
            }
          }
        }
      }
    }
  `)

  let allTags = []

  // let allNodes = data.allMarkdownRemark.edges
  let allNodes = AllTagsQuery.allMarkdownRemark.edges
  for (let index = 0; index < allNodes.length; index++) {
    const node = allNodes[index]
    allTags.push(node.node.frontmatter.tags)
  }

  // Flatten array of arrays of tags to get list of tags
  var flattenArrayOfTags = [].concat.apply([], allTags)

  // Get set of unique tags
  var uniqueTags = [...new Set(flattenArrayOfTags)]

  return (
    <TagWrapper>
      I have also written about: 
      {uniqueTags.map(singleTag => (
        <Tag key={singleTag} name={singleTag}></Tag>
      ))}
    </TagWrapper>
  )
}

export default TagList
